var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AttributeCategorizedList',{attrs:{"attributes":_vm.allAttributes,"categories":_vm.attributeCategories,"sort-by-blueprint":true,"save":_vm.save,"environments":_vm.environments}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }